import React from 'react';
import {connect} from 'react-redux';
import {Grid} from '@material-ui/core';
import {ExpandLess, ExpandMore} from '@material-ui/icons';

// Components
import Dialog from 'Components/common/Dialog';
import BasicButton from 'Components/common/BasicButton';
// import SearchInput from 'Components/common/SearchInput';
import ScrollWrapper from 'Components/common/ScrollWrapper';
import MultipleSelect from 'Components/common/MultipleSelect';
import ProductImage from 'Components/commonOrder/ProductImage';
import BasicInput from 'Components/common/BasicInput';
import BasicSwitch from 'Components/common/BasicSwitch';
import Select from 'Components/common/Select';
import SingleSelect from 'Components/common/SingleSelect';
import MyOrderItem from './MyOrderItem';
import util from 'Utils/commonUtil';

// Actions
import {
    getMyOrderSearchList,
    receiveShipment,
    repeatOrder,
    getShipments,
    getSearchSCLists,
    updateMyOrderSearchFields,
    updateMyOrderSearchList,
    getCustomerAccount,
    setCurrentOrderId,
    setSalesOrderOnholdStatus,
    updateSalesOrderListPageNum,
    setFromMyOrderDetails,
} from 'Actions/myOrder';
import {getOrderDetails, notShipOrder} from 'Actions/host';
import {openNotification} from 'Actions/notification';
import {setUserData, setSCData} from 'Actions/localData';
import {PURCHASE_ORDER_MODE, MY_ORDER_STATUS} from 'Utils/constant';
import {T} from 'Actions/translate';

class MyOrderSearch extends React.Component {
    pager = {
        page: 0,
        length: 10,
        total: 0,
        pageTotal: 9999999999999999999999999,
    };
    blurTimer = null;
    constructor(props) {
        super(props);
        this.state = {
            inputValue: '',
            isFocus: false,
            listLoaded: true,
            selectedItem: null,
            receiveShipment: null,
            receiveDialogOpened: false,
            isShowAdvancedOption: false,
            advanceOptionClassName: '',
            currentOrderSearchList: [],
            notShipDialogOpened: false,
            chooseCurrentOrderItem: null,
            onHoldId: 0,
            orderStatus: [
                {
                    label: T('wait_for_receiving'),
                    value: T('wait_for_receiving'),
                    value2: 3,
                },
                {
                    label: T('to_send_the_goods'),
                    value: T('to_send_the_goods'),
                    value2: 1,
                },
                {
                    label: T('off_the_stocks'),
                    value: T('off_the_stocks'),
                    value2: 4,
                },
                {
                    label: T('user_center_canceled'),
                    value: T('user_center_canceled'),
                    value2: -1,
                },
            ],
            orderType: [
                {
                    label: 'CR',
                    value: 'CR',
                },
                {
                    label: 'D1',
                    value: 'D1',
                },
                {
                    label: 'D2',
                    value: 'D2',
                },
                {
                    label: 'SO',
                    value: 'SO',
                },
                {
                    label: 'SE',
                    value: 'SE',
                },
            ],
            // notShippedDataList: [
            //     {
            //         name: T('shippment_temporary_all'),
            //         id: 0,
            //     },
            //     {
            //         name: T('shippment_temporary_not_shipped'),
            //         id: 1,
            //     },
            //     {
            //         name: T('shippment_temporary_pending_shipped'),
            //         id: 2,
            //     },
            // ],
            notShippedDataList: [
                {
                    label: T('shippment_temporary_all'),
                    value: 0,
                },
                {
                    label: T('shippment_temporary_not_shipped'),
                    value: 1,
                },
                {
                    label: T('shippment_temporary_pending_shipped'),
                    value: 2,
                },
            ],
        };

        this.props.getSearchSCLists();

        if (this.props.fromMyOrderDetails) {
            this.props.setFromMyOrderDetails({$set: false});
            this.refreshOnholdOrder();
        }
    }

    componentDidUpdate() {
        if (document.getElementsByClassName('my-order-search-header')) {
            document.getElementsByClassName('header-wrap')[0].style.height =
                document.getElementsByClassName('my-order-search-header')[0]
                    .clientHeight + 'px';
        }
    }

    refreshOnholdOrder = () => {
        let {currentOrderId, salesOnholdStatusFlag} = this.props;

        if (salesOnholdStatusFlag) {
            let currentMyOrderList = JSON.parse(
                JSON.stringify(this.props.myOrderSearchList),
            );

            currentMyOrderList.length > 0 &&
                currentMyOrderList.forEach((myOrderItem) => {
                    if (currentOrderId === myOrderItem.id) {
                        myOrderItem.status = MY_ORDER_STATUS.ONHOLD;
                    }
                });

            this.props.updateMyOrderSearchList(currentMyOrderList);

            this.props.setSalesOrderOnholdStatus({$set: false});
            this.pager.page = this.props.currentPageNum;
            this.props.setCurrentOrderId({$set: ''});
        }
    };

    orderOnHoldHandle = () => {
        const {chooseCurrentOrderItem} = this.state;
        this.props
            .notShipOrder({orderId: chooseCurrentOrderItem.id})
            .then((status) => {
                this.setState({
                    notShipDialogOpened: false,
                    chooseCurrentOrderItem: '',
                });
                this.props.openNotification(
                    T('my_order_on_hold_already_success'),
                    'success',
                    {
                        testid: 'my_order_on_hold_success',
                    },
                );
                this.refreshOnholdOrder();
            })
            .catch((res) => {
                if (res && res.message) {
                    if (res.message === 'Black_Sku') {
                        this.setState({
                            notShipDialogOpened: false,
                            chooseCurrentOrderItem: '',
                        });
                        this.props.openNotification(
                            T(
                                'grey_list_products_can_not_be_temporarily_shipped',
                            ),
                            'danger',
                        );
                    }
                }
            });
    };

    openNotShipDialog = (item) => {
        this.props.updateSalesOrderListPageNum({$set: this.pager.page});
        this.props.setSalesOrderOnholdStatus({$set: true});
        this.props.setCurrentOrderId({$set: parseInt(item.id)});
        this.setState({
            chooseCurrentOrderItem: item,
            notShipDialogOpened: true,
        });
    };

    getSearchHistoryTemplate = () => {
        return null;
        /* return (
            <React.Fragment>
                <p className="my-order-search-history-title">搜索历史</p>
                <ul className="my-order-search-history clearfix">
                    <li className="my-order-search-history-item"><Anchor className="my-order-search-history-value">0012345</Anchor></li>
                    <li className="my-order-search-history-item"><Anchor className="my-order-search-history-value">0012345</Anchor></li>
                    <li className="my-order-search-history-item"><Anchor className="my-order-search-history-value">0012345</Anchor></li>
                    <li className="my-order-search-history-item"><Anchor className="my-order-search-history-value">0012345</Anchor></li>
                    <li className="my-order-search-history-item"><Anchor className="my-order-search-history-value">0012345</Anchor></li>
                </ul>
            </React.Fragment>
        ); */
    };

    deliverInforHandle = (item) => {
        this.props.history.push(`/deliverDetails?orderId=${item.id}`);
    };

    getSearchListTemplate = () => {
        const {localData, orderSearchIsLastPage} = this.props;

        return (
            <ScrollWrapper
                listLoaded={this.state.listLoaded}
                showAbyss={orderSearchIsLastPage}
                showLoadingMore={!this.state.listLoaded}
                getMoreData={this.getList}>
                <ul className="my-order-search-list">
                    {this.props.myOrderSearchList &&
                        this.props.myOrderSearchList.map((item) => {
                            let isShipped = false;
                            item.orderProducts &&
                                item.orderProducts.forEach((product) => {
                                    if (product.shippedQuantity > 0)
                                        isShipped = true;
                                });

                            return (
                                <MyOrderItem
                                    key={item.id}
                                    item={item}
                                    chooseItem={this.chooseItem}
                                    options={{
                                        showTag: true,
                                        showTitle: true,
                                        showReceiveBtn:
                                            item.orderType === 'SCM' &&
                                            (item.status === 3 ||
                                                item.status === 2 ||
                                                item.status === 1) &&
                                            localData.roleType === 0 &&
                                            isShipped,
                                        receiveOrder: () =>
                                            this.openReceiveDialog(item),
                                        buyAgain: () => this.buyAgain(item),
                                        deliverInfor: () =>
                                            this.deliverInforHandle(item),
                                        orderOnHoldInfo: () => {
                                            this.openNotShipDialog(item);
                                        },
                                    }}></MyOrderItem>
                            );
                        })}
                </ul>
            </ScrollWrapper>
        );
    };

    search = () => {
        const type = this.getButtonText();

        switch (type) {
            case 'search':
                this.pager.page = 0;
                this.pager.total = 0;
                this.pager.pageTotal = 9999999999999999999999999;
                this.getList();
                break;
            default:
                this.props.history.goBack();
        }
    };

    cancelAdvancedQuery = () => {
        this.props.history.goBack();
    };

    advancedOrderQuery = () => {
        if (this.state.isShowAdvancedOption) {
            this.setState({
                isShowAdvancedOption: false,
                advanceOptionClassName: '',
            });
        }
        this.props.updateMyOrderSearchList([]);
        this.pager.page = 0;
        this.pager.total = 0;
        this.pager.pageTotal = 9999999999999999999999999;
        this.getList();
    };

    getList = () => {
        const {localData, myOrderSearchfields} = this.props;
        const statusArr = myOrderSearchfields.status.concat();
        if (
            myOrderSearchfields.status.indexOf(1) !== -1 &&
            myOrderSearchfields.onHold !== 0
        ) {
            statusArr.push(2);
        }
        if (
            myOrderSearchfields.beginTime !== '' &&
            myOrderSearchfields.endTime !== '' &&
            myOrderSearchfields.beginTime > myOrderSearchfields.endTime
        ) {
            this.props.openNotification(
                T(
                    'notification_purchase_start_time_shall_not_be_greater_than_the_end_time',
                ),
                'danger',
            );
            return;
        }
        // if(this.pager.page >= this.pager.pageTotal) return;

        this.setState({listLoaded: false});

        this.props
            .getMyOrderSearchList({
                pageNum: this.pager.page + 1,
                pageSize: this.pager.length,
                webAccount:
                    localData.roleType === 0
                        ? localData.customerEmail
                        : myOrderSearchfields.webAccount,
                orderE1Number: myOrderSearchfields.orderE1Number,
                sku: myOrderSearchfields.sku,
                scIds: myOrderSearchfields.scIds,
                institution: myOrderSearchfields.institution,
                receiver: myOrderSearchfields.receiver,
                purchaseNo: myOrderSearchfields.purchaseNo,
                shipTo: myOrderSearchfields.shipTo,
                status: statusArr,
                webOrderType: myOrderSearchfields.webOrderType,
                beginTime: myOrderSearchfields.beginTime,
                endTime: myOrderSearchfields.endTime,
                onHold:
                    localData.roleType === 0 ? '' : myOrderSearchfields.onHold,
            })
            .then((res) => {
                if (!res) return;
                this.pager.page = res.pageNum;
                this.pager.total = res.total;
                this.pager.pageTotal = res.pageTotal;
                this.setState({
                    currentOrderSearchList: res.data,
                });
            })
            .then(() => {
                this.setState({listLoaded: true});
            });
    };

    /* handleRadio = (params ,e) => {
        this.setState({
            [params]: parseInt(e.target.value)
        })
    } */

    handleChange = (title, value) => {
        console.log(title, value);
        const {searchSCLists} = this.props;

        if (document.getElementById(title) !== null) {
            if (!(title === 'beginTime' || title === 'endTime')) {
                if (!value) {
                    document.getElementById(title).style.visibility = 'hidden';
                } else {
                    document.getElementById(title).style.visibility = 'visible';
                }
            }
        }
        if (title === 'scIds') {
            const arrValue = [];
            searchSCLists.map((item) => {
                value.map((v) => {
                    if (v === item.value) {
                        arrValue.push(item.value2);
                    }

                    return null;
                });

                return null;
            });
            this.props.updateMyOrderSearchFields({
                [title]: {$set: arrValue},
                scIdsValue: {$set: value},
            });
        } else if (title === 'status') {
            const arrValue = [];
            this.state.orderStatus.map((item) => {
                value.map((v) => {
                    if (v === item.value) {
                        arrValue.push(item.value2);
                    }

                    return null;
                });

                return null;
            });
            this.props.updateMyOrderSearchFields({
                [title]: {$set: arrValue},
                statusValue: {$set: value},
            });
        } else if (title === 'onHold') {
            let selectedOption = this.state.notShippedDataList.find(
                (option) => option.value === value,
            );
            this.props.updateMyOrderSearchFields({
                [title]: {$set: selectedOption.value},
                onHoldValue: {$set: selectedOption.value},
            });
        } else {
            this.props.updateMyOrderSearchFields({[title]: {$set: value}});
        }
    };

    onFocus = () => {
        window.clearTimeout(this.blurTimer);
        this.setState({isFocus: true});
    };
    onBlur = () => {
        window.clearTimeout(this.blurTimer);
        this.blurTimer = window.setTimeout(() => {
            this.setState({isFocus: false});
        }, 300);
    };
    getButtonText = () =>
        this.state.isFocus && this.state.inputValue ? 'search' : 'cancel';

    chooseItem = (item) => {
        const {localData} = this.props;
        this.props.updateSalesOrderListPageNum({$set: this.pager.page});
        if (localData.roleType === 3) {
            this.props.history.push(`/myOrderDetail/${item.id}`, {
                status: item.status,
                orderLockType: util.getLockedType(item),
            });
        } else {
            this.props.history.push(`/myOrderDetail/${item.id}`);
        }
    };

    buyAgain = (item) => {
        const {localData} = this.props;

        this.props
            .repeatOrder({id: item.id, shipToNum: item.shipToNum})
            .then((res) => {
                if (localData.roleType !== 0) {
                    this.props.setUserData({
                        data: {
                            email: item.email,
                            shipToNum: item.shipToNum,
                            isProxyProcess: true,
                            type: localData.roleType,
                            name: localData.name,
                        },
                    });
                    if (
                        res &&
                        res.data &&
                        res.data.shipToSupplyCenter &&
                        res.data.shipToSupplyCenter.supplyCenterId
                    ) {
                        this.props.setSCData({
                            id: res.data.shipToSupplyCenter.supplyCenterId,
                            name: res.data.shipToSupplyCenter.supplyCenterName,
                        });
                    } else {
                        this.props.setSCData({
                            id: -1,
                            name: '',
                        });
                    }
                }

                this.reOrderSendData(
                    item.id,
                    res.data.shipToSupplyCenter,
                    item,
                );
            });
    };

    getOrderChannel = (orderNumber) => {
        let purchaseOrderMode = PURCHASE_ORDER_MODE.ONLINE;
        if (orderNumber.startsWith('P')) {
            purchaseOrderMode = PURCHASE_ORDER_MODE.OFFLINE;
        } else if (orderNumber.startsWith('C')) {
            purchaseOrderMode = PURCHASE_ORDER_MODE.ONLINE;
        }

        return purchaseOrderMode;
    };

    reOrderSendData = (orderId, supplyCenter, item) => {
        this.props.getOrderDetails({id: orderId}).then((res) => {
            if (res && res.status === 'success') {
                let orderProducts = res.data.orderProducts;
                if (orderProducts.length > 0) {
                    let tempCustomerName = undefined;
                    if (
                        this.getOrderChannel(item.number) ===
                        PURCHASE_ORDER_MODE.ONLINE
                    ) {
                        this.props
                            .getCustomerAccount({
                                email: item.email,
                                shipToNum: item.shipToNum,
                            })
                            .then((customerAccountRes) => {
                                if (
                                    customerAccountRes &&
                                    customerAccountRes.status === 'success' &&
                                    customerAccountRes.data
                                ) {
                                    tempCustomerName =
                                        customerAccountRes.data.lastName +
                                        customerAccountRes.data.firstName;
                                    this.reOrderGogoShoppingCart(
                                        item,
                                        tempCustomerName,
                                        supplyCenter,
                                        res,
                                    );
                                }
                            });
                    } else {
                        this.reOrderGogoShoppingCart(
                            item,
                            tempCustomerName,
                            supplyCenter,
                            res,
                        );
                    }
                }
            }
        });
    };

    reOrderGogoShoppingCart = (item, tempCustomerName, supplyCenter, res) => {
        localStorage.setItem(
            'ltoPurchaseOrderMode',
            this.getOrderChannel(item.number),
        );
        localStorage.setItem('purchaseCustomerEmail', item.email);
        localStorage.setItem('purchaseCustomerName', tempCustomerName);
        if (supplyCenter) {
            this.props.history.push('/purchase/shoppingCart', {
                customerEmail: item.email,
                customerName: tempCustomerName,
                fromReorder: true,
                scName: supplyCenter.supplyCenterName,
            });
        } else {
            this.props.history.push('/purchase/shoppingCart', {
                batchAddShipTo: item.shipToNum,
                batchAddEmail: item.email,
                customerEmail: item.email,
                customerName: tempCustomerName,
            });
        }
    };

    receiveOrder = () => {
        const {receiveShipment} = this.state;

        this.props
            .receiveShipment({shipmentId: receiveShipment.id})
            .then(() => {
                this.props.openNotification(
                    T('notification_successful_receipt_of_goods'),
                    'success',
                );
                this.dialogDidClose('receiveDialogOpened');
                this.pager.page = 0;
                this.pager.total = 0;
                this.pager.pageTotal = 9999999999999999999999999;
                this.getList();
            });
    };

    openReceiveDialog = (item) => {
        this.props.getShipments({id: item.id}).then((res) => {
            let shipments = res.data.shipments || [];
            let receiveShipment = null;

            for (let i = 0; i < shipments.length; i++) {
                if (shipments[i].status === 3) {
                    receiveShipment = shipments[i];
                    break;
                }
            }

            this.setState({
                receiveDialogOpened: true,
                receiveShipment,
                selectedItem: item,
            });
        });
    };
    dialogDidClose = (key) => this.state[key] && this.setState({[key]: false});

    expandPackageCondition = () => {
        let advanceOptionClassName = '';
        if (this.state.isShowAdvancedOption) {
            this.setState({
                isShowAdvancedOption: false,
                advanceOptionClassName: advanceOptionClassName,
            });
        } else {
            advanceOptionClassName = ' display-advanced-option';
            this.setState({
                isShowAdvancedOption: true,
                advanceOptionClassName: advanceOptionClassName,
            });
        }
    };

    handleCurrentOnHoldChange = (item) => this.setState({onHoldId: item.id});

    render() {
        const {searchSCLists, localData, myOrderSearchfields} = this.props;
        const {
            isFocus,
            selectedItem,
            receiveShipment,
            receiveDialogOpened,
            advanceOptionClassName,
            isShowAdvancedOption,
            orderStatus,
            orderType,
            notShipDialogOpened,
            onHoldId,
            notShippedDataList,
        } = this.state;
        return (
            <div className="my-order-search-container">
                <div className="header-wrap">
                    <div className="my-order-search-header container-max-width is-fixed">
                        <Grid className="advanced-order-area">
                            <Grid className="show-basic-options" item xs={12}>
                                <Grid
                                    className="orderNo-eoneNo first-column no-bottom-style"
                                    item
                                    xs={6}>
                                    <label
                                        className="order-search-label"
                                        id="orderE1Number">
                                        {T('enter_orderNo_eoneNo')}
                                    </label>
                                    <BasicInput
                                        placeholder={T('enter_orderNo_eoneNo')}
                                        testid="order-search-order-e1-number"
                                        title="orderE1Number"
                                        defaultValue={
                                            myOrderSearchfields.orderE1Number
                                        }
                                        inputValid={this.handleChange}
                                        smallBasicInput={true}
                                    />
                                </Grid>
                                <Grid
                                    className={
                                        localData.roleType === 3
                                            ? 'advance-orderNo-subject no-bottom-style'
                                            : 'advanced-sku no-bottom-style'
                                    }
                                    item
                                    xs={6}>
                                    <label
                                        className={'order-search-label'}
                                        id={
                                            localData.roleType === 3
                                                ? 'institution'
                                                : 'sku'
                                        }>
                                        {localData.roleType === 3
                                            ? T('order_subject')
                                            : T('backup_sku')}
                                    </label>
                                    <BasicInput
                                        placeholder={
                                            localData.roleType === 3
                                                ? T('order_subject')
                                                : T('backup_sku')
                                        }
                                        title={
                                            localData.roleType === 3
                                                ? 'institution'
                                                : 'sku'
                                        }
                                        defaultValue={
                                            localData.roleType === 3
                                                ? myOrderSearchfields.institution
                                                : myOrderSearchfields.sku
                                        }
                                        inputValid={this.handleChange}
                                        smallBasicInput={true}
                                    />
                                </Grid>
                            </Grid>
                            <Grid className="show-basic-options" item xs={12}>
                                <Grid className="supply-center-name no-bottom-style">
                                    <label
                                        className="order-search-label order-search-display-label"
                                        id="scIds"></label>
                                    <MultipleSelect
                                        multipleSelectPlaceholder={T(
                                            'backup_supply_center_placeholder',
                                        )}
                                        title="scIds"
                                        defaultValue={
                                            myOrderSearchfields.scIdsValue
                                        }
                                        selectOptions={searchSCLists}
                                        onChange={this.handleChange}
                                        placeholders={T('scName')}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                className={
                                    'show-advanced-options' +
                                    advanceOptionClassName
                                }
                                item
                                xs={12}>
                                <Grid
                                    className={
                                        localData.roleType === 3
                                            ? 'advanced-sku first-column no-bottom-style'
                                            : 'advance-orderNo-subject first-column no-bottom-style'
                                    }
                                    item
                                    xs={6}>
                                    <label
                                        className="order-search-label"
                                        id={
                                            localData.roleType === 3
                                                ? 'sku'
                                                : 'institution'
                                        }>
                                        {localData.roleType === 3
                                            ? T('backup_sku')
                                            : T('order_subject')}
                                    </label>
                                    <BasicInput
                                        placeholder={
                                            localData.roleType === 3
                                                ? T('backup_sku')
                                                : T('order_subject')
                                        }
                                        title={
                                            localData.roleType === 3
                                                ? 'sku'
                                                : 'institution'
                                        }
                                        defaultValue={
                                            localData.roleType === 3
                                                ? myOrderSearchfields.sku
                                                : myOrderSearchfields.institution
                                        }
                                        inputValid={this.handleChange}
                                        smallBasicInput={true}
                                    />
                                </Grid>
                                <Grid
                                    className="advanced-order-consignee no-bottom-style"
                                    item
                                    xs={6}>
                                    <label
                                        className="order-search-label"
                                        id="receiver">
                                        {T('order_consignee')}
                                    </label>
                                    <BasicInput
                                        placeholder={T('order_consignee')}
                                        title="receiver"
                                        defaultValue={
                                            myOrderSearchfields.receiver
                                        }
                                        inputValid={this.handleChange}
                                        smallBasicInput={true}
                                    />
                                </Grid>
                            </Grid>
                            {localData.roleType === 0 ? (
                                <Grid
                                    className={
                                        'show-advanced-options' +
                                        advanceOptionClassName
                                    }
                                    item
                                    xs={12}>
                                    <Grid
                                        className="advance-order-purchase-number-12 first-column no-bottom-style"
                                        item
                                        xs={12}>
                                        <label
                                            className="order-search-label"
                                            id="purchaseNo">
                                            {T('enter_order_purchase_number')}
                                        </label>
                                        <BasicInput
                                            placeholder={T(
                                                'enter_order_purchase_number',
                                            )}
                                            inputValid={this.handleChange}
                                            title="purchaseNo"
                                            defaultValue={
                                                myOrderSearchfields.purchaseNo
                                            }
                                            smallBasicInput={true}
                                        />
                                    </Grid>
                                </Grid>
                            ) : (
                                <Grid
                                    className={
                                        'show-advanced-options' +
                                        advanceOptionClassName
                                    }
                                    item
                                    xs={12}>
                                    <Grid
                                        className="advance-order-purchase-number first-column no-bottom-style"
                                        item
                                        xs={6}>
                                        <label
                                            className="order-search-label"
                                            id="purchaseNo">
                                            {T('enter_order_purchase_number')}
                                        </label>
                                        <BasicInput
                                            placeholder={T(
                                                'enter_order_purchase_number',
                                            )}
                                            inputValid={this.handleChange}
                                            title="purchaseNo"
                                            defaultValue={
                                                myOrderSearchfields.purchaseNo
                                            }
                                            smallBasicInput={true}
                                        />
                                    </Grid>
                                    <Grid
                                        className="advanced-st no-bottom-style"
                                        item
                                        xs={6}>
                                        <label
                                            className="order-search-label"
                                            id="shipTo">
                                            {T('ST')}
                                        </label>
                                        <BasicInput
                                            placeholder={T('ST')}
                                            title="shipTo"
                                            defaultValue={
                                                myOrderSearchfields.shipTo
                                            }
                                            inputValid={this.handleChange}
                                            smallBasicInput={true}
                                        />
                                    </Grid>
                                </Grid>
                            )}
                            {localData.roleType !== 0 ? (
                                <Grid
                                    className={
                                        'show-advanced-options' +
                                        advanceOptionClassName
                                    }
                                    item
                                    xs={12}>
                                    <Grid
                                        className="advance-user-account first-column no-bottom-style"
                                        item
                                        xs={12}>
                                        <label
                                            className="order-search-label"
                                            id="webAccount">
                                            {T('enter_user_account')}
                                        </label>
                                        <BasicInput
                                            placeholder={T(
                                                'enter_user_account',
                                            )}
                                            inputValid={this.handleChange}
                                            title="webAccount"
                                            defaultValue={
                                                myOrderSearchfields.webAccount
                                            }
                                            smallBasicInput={true}
                                        />
                                    </Grid>
                                </Grid>
                            ) : null}
                            <Grid
                                className={
                                    'show-advanced-options' +
                                    advanceOptionClassName
                                }
                                item
                                xs={12}>
                                <Grid
                                    className="advanced-order-status"
                                    item
                                    xs={12}>
                                    <label className="order-search-label order-search-display-label"></label>
                                    <MultipleSelect
                                        multipleSelectPlaceholder={T(
                                            'order_status_placeholder',
                                        )}
                                        selectOptions={orderStatus}
                                        title="status"
                                        defaultValue={
                                            myOrderSearchfields.statusValue
                                        }
                                        onChange={this.handleChange}
                                        placeholders={T('enter_order_status')}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                className={
                                    'show-advanced-options' +
                                    advanceOptionClassName
                                }
                                item
                                xs={12}>
                                <Grid
                                    className="advanced-order-type first-column"
                                    item
                                    xs={12}>
                                    <label
                                        className="order-search-label order-search-display-label"
                                        id="webOrderType"></label>
                                    <MultipleSelect
                                        multipleSelectPlaceholder={T(
                                            'order_type_placeholder',
                                        )}
                                        selectOptions={orderType}
                                        title="webOrderType"
                                        defaultValue={
                                            myOrderSearchfields.webOrderType
                                        }
                                        onChange={this.handleChange}
                                        placeholders={T(
                                            'enter_advanced_order_type',
                                        )}
                                    />
                                </Grid>
                            </Grid>
                            <Grid
                                className={
                                    'show-advanced-options' +
                                    advanceOptionClassName
                                }
                                item
                                xs={12}>
                                <Grid
                                    className="advanced-order-consignee first-column no-bottom-style purchase-date"
                                    item
                                    xs={6}>
                                    <label
                                        className="order-search-label order-search-display-label"
                                        id="beginTime">
                                        {T('order_purchase_date')}
                                    </label>
                                    {/* {<DatePickers  title='beginTime' onChange={this.handleChange}/>} */}
                                    {
                                        <BasicInput
                                            placeholder={T(
                                                'order_purchase_date_placeholder',
                                            )}
                                            type={'date'}
                                            inputValid={this.handleChange}
                                            smallBasicInput={true}
                                            defaultValue={
                                                myOrderSearchfields.beginTime
                                            }
                                            title="beginTime"
                                        />
                                    }
                                </Grid>
                                <Grid
                                    className="advanced-order-consignee no-bottom-style purchase-date"
                                    item
                                    xs={6}>
                                    <label
                                        className="order-search-label"
                                        id="endTime"></label>
                                    {/* <DatePickers title='endTime' onChange={this.handleChange}/> */}
                                    <BasicInput
                                        type={'date'}
                                        inputValid={this.handleChange}
                                        smallBasicInput={true}
                                        defaultValue={
                                            myOrderSearchfields.endTime
                                        }
                                        title="endTime"
                                    />
                                </Grid>
                            </Grid>

                            {localData.roleType !== 0 ? (
                                <Grid
                                    className={
                                        'show-advanced-options' +
                                        advanceOptionClassName
                                    }
                                    item
                                    xs={12}>
                                    <Grid
                                        className="advanced-on-hold"
                                        item
                                        xs={12}>
                                        <label className="order-search-label order-search-display-label">
                                            {T(
                                                'shippment_temporary_not_delivery',
                                            )}
                                        </label>
                                        {/* <BasicSwitch
                                            title="onHold"
                                            defaultValue={
                                                myOrderSearchfields.onHoldValue
                                            }
                                            onChange={
                                                this.handleChange
                                            }></BasicSwitch> */}
                                        {/* <Select
                                        className="select"
                                        value={onHoldId}
                                        placeholder={T('st_management_please_select_apply_sp')}
                                        data={notShippedDataList}
                                        displayKey="name"
                                        valueKey="id"
                                        onChange={this.handleCurrentOnHoldChange}
                                        options={{icon: {show: true, color: 'rgba(0, 0, 0, 0.87)'}}}
                                    />	 */}

                                        <SingleSelect
                                            title="onHold"
                                            defaultValue={onHoldId}
                                            optionObj={
                                                myOrderSearchfields.onHold
                                            }
                                            selectOptions={notShippedDataList}
                                            onChange={this.handleChange}
                                            placeholders={T('全部')}
                                        />
                                    </Grid>
                                </Grid>
                            ) : null}
                        </Grid>
                        <Grid className="expand-more-search-container">
                            {/* <Anchor className="expand-more-search-btn" type="primary" disable="true" onClickOfSingleTap={()=>this.expandPackageCondition()}>
                                    <Grid><label>{T('query-order-more-options')}</label>{isShowAdvancedOption ? <ExpandLess /> : <ExpandMore />}</Grid>
                            </Anchor> */}

                            <BasicButton
                                className="expand-more-search-btn"
                                testid="expand-more-search-btn"
                                item
                                xs={6}
                                type="primary"
                                onClickOfSingleTap={() =>
                                    this.expandPackageCondition()
                                }>
                                <span className="more-options-label">
                                    <label>
                                        {T('query-order-more-options')}
                                    </label>
                                    {isShowAdvancedOption ? (
                                        <ExpandLess />
                                    ) : (
                                        <ExpandMore />
                                    )}
                                </span>
                            </BasicButton>
                        </Grid>

                        <Grid
                            className="order-advance-search-button"
                            item
                            xs={12}>
                            <BasicButton
                                className="cancel-advanced-query"
                                testid="cancel-advanced-query"
                                item
                                xs={6}
                                type="primary"
                                onClickOfSingleTap={() =>
                                    this.cancelAdvancedQuery()
                                }>
                                <span>{T('cancel')}</span>
                            </BasicButton>
                            <BasicButton
                                item
                                testid="customer-order-search-btn"
                                xs={6}
                                type="primary"
                                onClickOfSingleTap={() =>
                                    this.advancedOrderQuery()
                                }>
                                <span>{T('search')}</span>
                            </BasicButton>
                        </Grid>
                    </div>
                </div>

                {isFocus
                    ? this.getSearchHistoryTemplate()
                    : this.getSearchListTemplate()}
                <Dialog
                    opened={receiveDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('receiveDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="receive-order-confirm-dialog">
                        <h5>
                            {selectedItem && selectedItem.partialDelivery
                                ? T('order_partial_receipt_confirm')
                                : T('order_full_receipt_confirm')}
                        </h5>
                        <ul className="product-list">
                            {receiveShipment &&
                                receiveShipment.shipmentProducts &&
                                receiveShipment.shipmentProducts.map(
                                    (item, index) =>
                                        item.shippedQuantity > 0 ? (
                                            <li key={index}>
                                                <p
                                                    className="product-name"
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            item.product &&
                                                            item.product
                                                                .productName,
                                                    }}
                                                />
                                                <div className="details">
                                                    <div className="image-box">
                                                        <ProductImage
                                                            src={
                                                                item.product &&
                                                                item.product
                                                                    .productPic
                                                            }
                                                            alt={
                                                                item.product &&
                                                                item.product
                                                                    .productName
                                                            }
                                                            key={
                                                                item.product &&
                                                                item.product
                                                                    .productPic
                                                            }
                                                        />
                                                    </div>
                                                    <div className="details-text">
                                                        <p className="text-ellipsis">
                                                            {T(
                                                                'product_specifications_colon',
                                                            )}
                                                            <div
                                                                dangerouslySetInnerHTML={{
                                                                    __html:
                                                                        item.product &&
                                                                        item
                                                                            .product
                                                                            .specifications,
                                                                }}
                                                            />
                                                        </p>
                                                        <p className="text-ellipsis">
                                                            {T(
                                                                'not_shippment_quantity_colon',
                                                            )}{' '}
                                                            {item.tobeshippedQuantity ||
                                                                item.onholdQuantity}
                                                        </p>
                                                        <p className="point text-ellipsis">
                                                            {T(
                                                                'order_current_shippment_number_colon',
                                                            )}{' '}
                                                            {item.quantity}
                                                        </p>
                                                    </div>
                                                </div>
                                            </li>
                                        ) : null,
                                )}
                        </ul>
                        <BasicButton
                            type="primary"
                            className="confirm-btn"
                            onClickOfSingleTap={() => this.receiveOrder()}>
                            {T('order_confirm_receive')}
                        </BasicButton>
                    </div>
                </Dialog>
                <Dialog
                    opened={notShipDialogOpened}
                    testid="my_order_searcg_onhold_dialog"
                    dialogDidClose={() =>
                        this.dialogDidClose('notShipDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="not-ship-dialog">
                        <h5 className="not-ship-dialog-title text-center">
                            {T('shippment_confirm_temporary_delivery')}
                        </h5>
                        <div className="not-ship-dialog-desc">
                            <p>{T('shippment_if_temporary_delivery')}</p>
                        </div>
                        <BasicButton
                            type="primary"
                            className="not-ship-confirm-btn"
                            testid="my_order_searcg_onhold_dialog_confirm_btn"
                            onClickOfSingleTap={this.orderOnHoldHandle}>
                            {T('shippment_confirm')}
                        </BasicButton>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {myOrder, localData} = state;

    return {
        myOrderSearchList: myOrder.myOrderSearchList,
        localData: localData,
        searchSCLists: myOrder.searchSCLists,
        myOrderSearchfields: myOrder.myOrderSearchfields,
        orderSearchIsLastPage: myOrder.orderSearchIsLastPage,
        salesOnholdStatusFlag: myOrder.salesOnholdStatusFlag,
        currentOrderId: myOrder.currentOrderId,
        currentPageNum: myOrder.currentPageNum,

        fromMyOrderDetails: myOrder.fromMyOrderDetails,
    };
};

const mapDispatchToProps = {
    openNotification,
    getMyOrderSearchList,
    receiveShipment,
    repeatOrder,
    setUserData,
    getShipments,
    setSCData,
    getSearchSCLists,
    updateMyOrderSearchFields,
    getOrderDetails,
    updateMyOrderSearchList,
    getCustomerAccount,

    setSalesOrderOnholdStatus,
    updateSalesOrderListPageNum,
    setCurrentOrderId,
    notShipOrder,

    setFromMyOrderDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(MyOrderSearch);
